import GroupBy from "@/components/GroupBy.vue";
import LoadingElement from "@/components/shared/LoadingElement.vue";
import { mapState } from "vuex";
export default {
  name: "PerformanceProductTableGroupBy",
  components: {
    GroupBy,
    LoadingElement
  },
  emits: ["refresh", "clicked"],
  props: {
    tabBusy: {
      type: Boolean
    }
  },
  computed: {
    ...mapState({
      groupByElements: state => state.market_insights.product_table.group_by_elements
    }),
    groupByIndex: {
      get() {
        return this.$store.getters.marketInsightsGetProductTableGroupBy();
      },
      set(val) {
        this.$store.dispatch("marketInsightsSetProductTableGroupBy", val);
        this.$emit("refresh");
      }
    }
  },
  methods: {
    handleClicked() {
      this.$emit('clicked');
    }
  }
};